



































import { Component, Vue } from 'vue-property-decorator';

import AttendanceProfile from "@/components/AttendanceProfile.vue";
import AttendanceDetailsTable from "@/components/AttendanceDetailsTable.vue";
import Logout from '@/components/Logout.vue';
import Title from "@/components/Title.vue";

import { AuthUtile } from "../../auth/AuthUtile";
import { DbUtile, ResultDbCourseManagementDetails } from "../../database/DbUtile";
import { DbUser, DbUserCourseManagementDetail } from '../../database/DbUser';
import { DbCourseManagementDetails } from "../../database/DbCourseManagement";

import Common from "@/common/Common";
import BackButton from '@/components/BackButton.vue';

@Component({
  components: {
    AttendanceProfile,
    AttendanceDetailsTable,
    BackButton,
    Logout,
    Title
  }
})
export default class AttendanceDetails extends Vue {
  private authUtile: AuthUtile = new AuthUtile();
  private dbUtile: DbUtile = new DbUtile();

  // 管理者モードの確認
  isAdmin = false;

  // 現在日時
  now = new Date();

  userId: string | null = null;
  user: DbUser | null = null;

  // 講習ID
  private courseManagementId = "";
  // 講習詳細 一覧
  private courseManagementDetails: ResultDbCourseManagementDetails[] = [];
  // ユーザー受講詳細Map
  private userCourseManagementDetailMap: Map<string, DbUserCourseManagementDetail> = new Map();

  // ライブ配信 – 予定 （現在日時 <= 終了日時）ライブ配信の章
  liveRow: ResultDbCourseManagementDetails[] = [];
  // 動画 – 受講中
  duringRow: ResultDbCourseManagementDetails[] = [];
  // 動画 - 受講完了
  doneRow: ResultDbCourseManagementDetails[] = [];
  // ライブ配信– 終了
  expiredRow: ResultDbCourseManagementDetails[] = [];

  // ソート
  isSortCourseManagementDetails = false;

  // 表示更新Interval
  updateDisplayInterval: NodeJS.Timeout | null = null;

  created() {
    console.log('created', this.user);
    this.authUtile.onAuthStateChanged()
      .then((user) => {
        // ログイン済み
        this._created();
      })
      .catch((e) => {
        console.error(e);
        alert('ログインしてください');
        const path = Common.getLoginPath(this.$route.path, this.$route.params.admin);
        this.$router.push(path);
      });
  }

  _created() {
    console.log('_created', this.$route.params);
    const currentUser = this.authUtile.currentUser();
    if (currentUser == null){
      this.$router.push("/students/login");
      return;
    }
    this.courseManagementId = this.$route.params['id'];
    if ('admin' in this.$route.params) {
      this.isAdmin = (this.$route.params['admin'] == 'true') ? true : false;
    }

    // ユーザー詳細 取得
    this.dbUtile.getCourseManagementUser(this.courseManagementId, currentUser.uid!)
      .then((u) => {
        console.log('u', u);
        this.userId = u.id!;
        this.user = u.u!;
        // 講習詳細を取得
        this.getCourseManagementDetails();
      })
      .catch((e) => {
        if (this.isAdmin == false) {
          console.error(e);
        }
        else {
          this.user = null;
          // 講習詳細を取得
          this.getCourseManagementDetails();
        }
      });
  }

  destroyed() {
    console.log('destroyed');
    this.clearUpdateDisplayInterval();
  }

  // 講習詳細を取得
  async getCourseManagementDetails() {
    console.log('getCourseManagementDetails', this.user);
    // 講習詳細を取得
    this.courseManagementDetails = await this.dbUtile.getCourseManagementDetails(this.courseManagementId);
    // 履歴詳細を取得
    const userHistoryManagementDetails = this.isAdmin ? null : await this.dbUtile.getUserHistoryManagementDetails(this.userId!, this.courseManagementId, '', '');

    // ユーザー受講詳細を取得
    for (const cmd of this.courseManagementDetails) {
      if (this.isAdmin || Common.isLive(cmd.courseManagementDetails!)) continue;
      const uhmd = userHistoryManagementDetails?.find(uhmd => uhmd.courseManagementDetailsId === cmd.id);
      const ucmd = await Common.getUserCourseManagementDetail(uhmd, this.user!, this.userId!, this.courseManagementId, cmd);
      this.userCourseManagementDetailMap.set(cmd.id!, ucmd);
    }
    // 講習情報表示
    this.setDisplayCourseManagementDetails();
    // 講習情報表示の定期更新設定（10秒毎）
    if (this.updateDisplayInterval === null) this.updateDisplayInterval = setInterval(this.setDisplayCourseManagementDetails, 10000);
  }

  // 講習情報の表示設定
  setDisplayCourseManagementDetails() {
    // console.log('setDisplayCourseManagementDetails', this.user);
    // ソート終わり
    this.isSortCourseManagementDetails = false;
    // 現在時刻
    this.now = new Date();
    // ライブ配信 – 予定 （現在日時 <= 終了日時）ライブ配信の章
    this.liveRow = [];
    // 動画 – 受講中
    this.duringRow = [];
    // 動画 - 受講完了
    this.doneRow = [];
    // ライブ配信– 終了
    this.expiredRow = [];

    this.courseManagementDetails.forEach((v) => {
      const cmd = v.courseManagementDetails!;
      const subcommitteeNumber = cmd.subcommitteeNumber;
      const to = new Date(cmd.to);
      // ライブ配信
      if (Common.isLive(cmd)) {
        // ライブ配信 – 予定
        if (this.now <= to) {
          // 受講者の場合
          if (this.isAdmin == false) {
            if (this.user == null) {
              this.liveRow.push(v);
            } else {
              // 分科会 なし
              if (this.user.applicationLecturesSubcommittees.length == 0){
                this.liveRow.push(v);
              // 分科会 あり
              } else {
                this.user.applicationLecturesSubcommittees.forEach(a => {
                  if (a == subcommitteeNumber) this.liveRow.push(v);
                });
              }
            }
          // 管理者の場合
          } else {
            this.liveRow.push(v);
          }
        // ライブ配信 - 終了
        } else {
          // 受講者の場合
          if (this.isAdmin == false) {
            if (this.user == null) {
              this.expiredRow.push(v);
            } else {
              // 分科会 なし
              if (this.user.applicationLecturesSubcommittees.length == 0){
                this.expiredRow.push(v);
              // 分科会 あり
              } else {
                this.user.applicationLecturesSubcommittees.forEach(a => {
                  if (a == subcommitteeNumber) this.expiredRow.push(v);
                });
              }
            }
          // 管理者の場合
          } else {
            this.expiredRow.push(v);
          }
        }
      // 動画
      } else {
        const ucmd = this.userCourseManagementDetailMap.get(v.id!);
        // 動画 - 受講完了
        if (ucmd?.status == DbUserCourseManagementDetail.STATUS.Done) {
          if (this.user == null) {
            this.doneRow.push(v);
          } else {
            // 分科会 なし
            if (this.user.applicationLecturesSubcommittees.length == 0) {
              this.doneRow.push(v);
            // 分科会 あり
            } else {
              const subcommitteeNumber = cmd.subcommitteeNumber;
              this.user.applicationLecturesSubcommittees.forEach(a => {
                if (a == subcommitteeNumber) this.doneRow.push(v);
              });
            }
          }
        // 動画 – 受講中
        } else {
          if (this.user == null) {
            this.duringRow.push(v);
          } else {
            if (this.user.applicationLecturesSubcommittees.length == 0){
              // 分科会 なし
              this.duringRow.push(v);
            } else {
              // 分科会 あり
              const subcommitteeNumber = cmd.subcommitteeNumber;
              this.user.applicationLecturesSubcommittees.forEach(a => {
                if (a == subcommitteeNumber) this.duringRow.push(v);
              });
            }
          }
        }
      }
    });

    // ソート
    this.sortCourseManagementDetails(this.liveRow);
    this.sortCourseManagementDetails(this.duringRow);
    this.sortCourseManagementDetails(this.doneRow);
    this.sortCourseManagementDetails(this.expiredRow);
    // ソート終わり
    this.isSortCourseManagementDetails = true;
  }

  // ソート
  sortCourseManagementDetails(rows: ResultDbCourseManagementDetails[]): ResultDbCourseManagementDetails[]{
    return rows.sort((a,b) => {
      // 分科会番号 章IDで並び替え
      const aCourseManagementDetails = a.courseManagementDetails!;
      const bCourseManagementDetails = b.courseManagementDetails!;

      // 分科会番号
      if(aCourseManagementDetails.subcommitteeNumber > bCourseManagementDetails.subcommitteeNumber){
        return 1;
      }
      else if(aCourseManagementDetails.subcommitteeNumber < bCourseManagementDetails.subcommitteeNumber){
        return -1;
      }

      // 章ID
      if(aCourseManagementDetails.chapterID > bCourseManagementDetails.chapterID){
        return 1;
      }
      else if(aCourseManagementDetails.chapterID < bCourseManagementDetails.chapterID){
        return -1;
      }

      return 0;
    });
  }

  // 戻るボタン
  clickBack() {
    if (this.isAdmin == true) {
      window.history.go(-1);
    }
    else {
      this.$router.push({ name: 'Attendance' });
    }
  }

  clearUpdateDisplayInterval() {
    if (this.updateDisplayInterval === null) return;
    clearInterval(this.updateDisplayInterval);
    this.updateDisplayInterval = null;
  }
}
